import React, { useState, useCallback } from "react";

import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FilesForm from "../../../../Components/Files/FilesForm";
import Paper from "Components/UI/Paper";
import { downloadFile, uploadFile } from "API/swesum";
import usePost from "Hooks/usePost";
import { updateFile } from "API/swesum";
import ButtonGroup from "@mui/material/ButtonGroup";
import CloudUpload from "@mui/icons-material/CloudUpload";
import DownloadIcon from "@mui/icons-material/Download";
import { usePopupNotificationContext } from "Context/NotificationPopup";

export function FilesCard({ file }) {
  const { openSuccess, openError } = usePopupNotificationContext();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    Id: file.Id,
    SystemStatus: file.SystemStatus,
    ParseStatus: file.ParseStatus,
    ParseMessage: file.ParseMessage,
    Name: file.Name,
    FileType: file.FileType,
    Category: file.Category,
    IsCompleted: file.IsCompleted,
  });

  const [fileObj, setFileObj] = useState(null);

  const updateFileReq = usePost({
    mtnFunc: (body) => {
      return updateFile(file.Id, body);
    },
    onSuccess: (data) => {
      openSuccess("Sparat", 3000);
    },
    onError: (err) => {
      openError("Ett fel har uppstått.", 2000);
    },
  });

  const uploadFileReq = usePost({
    mtnFunc: (multipartFormData) => uploadFile(multipartFormData),
    onError: () => {
      openError("Ett fel uppstod när filen skulle laddas upp.");
    },
    onSuccess: () => {
      updateFileReq.post(formData);
    },
  });

  const downloadFileReq = usePost({
    mtnFunc: (id, fileType, fileName) => downloadFile(id, fileType, fileName),
    onError: () => {
      openError("Ett fel uppstod när filen skulle laddas upp.");
    },
    onSuccess: (res) => {
      const fileBlob = new Blob([res], { type: formData.FileType });

      // Create a temporary URL for the Blob
      const fileUrl = URL.createObjectURL(fileBlob);

      // Create a link element and simulate a click to trigger the download
      const downloadLink = document.createElement("a");
      downloadLink.href = fileUrl;
      downloadLink.download = formData.Name; // Set the desired file name
      downloadLink.click();

      // Clean up the temporary URL
      URL.revokeObjectURL(fileUrl);
    },
  });

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const handleDownloadFile = async () => {
    downloadFileReq.post(formData.Id, formData.FileType, formData.Name);
  };

  const handleFileSelect = ({ target }) => {
    if (target.files[0] !== undefined) {
      const fileReader = new FileReader();
      const file = target.files[0];
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        setFileObj({
          Content: file,
          FileType: file.type,
          FileName: file.name,
        });
        setFormData({
          ...formData,
          Name: `${file.name}`,
          FileType: `${file.type}`,
        });
      };
    }
  };

  const save = () => {
    if (fileObj != null) {
      const multipartFormDataObj = new FormData();
      multipartFormDataObj.append("FileType", fileObj.FileType);
      multipartFormDataObj.append(
        "Content",
        new Blob([fileObj.Content], { type: fileObj.Content.type }),
        fileObj.FileName
      );
      multipartFormDataObj.append("Id", formData.Id);
      uploadFileReq.post(multipartFormDataObj);
    } else {
      updateFileReq.post(formData);
    }
  };

  return (
    <>
      <Paper>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography sx={{ marginBottom: "1.0rem" }} variant="h5" align="left">
            Fil
          </Typography>

          <ButtonGroup variant="contained" color="primary">
            <Button startIcon={<CloudUpload />} component="label">
              Ny
              <input type="file" hidden onChange={handleFileSelect} />
            </Button>
            <Button
              onClick={handleDownloadFile}
              startIcon={<DownloadIcon />}
              component="label"
            >
              Ladda ner
            </Button>
          </ButtonGroup>
        </Box>
        {formData && (
          <FilesForm
            formData={formData}
            handleInputChange={handleInputChange}
          />
        )}

        <Grid
          item
          xs={12}
          md={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
            Stäng
          </Button>
          <Button onClick={save} variant="contained" sx={{ ml: 3 }}>
            Spara
          </Button>
        </Grid>
      </Paper>
    </>
  );
}
